import { render, staticRenderFns } from "./ms-select-bodypart.vue?vue&type=template&id=595bbda6&scoped=true"
import script from "./ms-select-bodypart.vue?vue&type=script&lang=js"
export * from "./ms-select-bodypart.vue?vue&type=script&lang=js"
import style0 from "./ms-select-bodypart.vue?vue&type=style&index=0&id=595bbda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595bbda6",
  null
  
)

export default component.exports